import WatchedVideoCard from "../Atomics/WatchedVideoCard/WatchedVideoCard";

export default function WatchedVideos({ videos }) {
  return (
    <>
      {videos?.map((item, index) => (
        <WatchedVideoCard
          key={index} 
          imgSrc={item.video?.cover ? item.video?.cover : "img/v1.png"}
          time={item.video?.duration}
          videoTitle={item.video?.title}
          views={item.video?.counted_views}
          timeAgo={item.video?.published_date}
          videoCategory={item.video?.category?.name}
          progress={item?.percentage_watched > 2 ? item?.percentage_watched : 2}
          progressTime={Math.floor(item?.percentage_watched) + "%"}
          verified
          videoId={item.video?.id}
        />
      ))}
    </>
  );
}
